import { Cover, Header, Main } from 'components';
import { useEffect, useState } from 'react';
import { services } from 'static';
import { CoverData } from 'types';

import { Section } from './styles';

export const SymptomsCheck: React.FC = () => {
  const [coverContent, setCoverContent] = useState<CoverData>({} as CoverData);

  useEffect(() => {
    setCoverContent(
      services.filter(({ slug }) => slug === '/saude/sintomas').shift()?.cover || ({} as CoverData)
    );
  }, []);

  return (
    <>
      <Header />
      <Main>
        <Cover {...coverContent} />
        <Section>
          <p>A equipa Hi! está a desenvolver esta área. Muito brevemente estará disponível.</p>
        </Section>
      </Main>
    </>
  );
};
